import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../pages/LoginPage.css";

export const LandingFooter: React.FC = () => {
  const { t, i18n } = useTranslation();

  return (
    <footer className="lp-foot">
      <div className="wrap lp-foot-inner">
        <Link className="lp-brand" to="/" aria-label="Trend">
          <span className="lp-brand-wm">TREND</span>
        </Link>
        <nav className="lp-foot-links">
          <Link to="/privacy">{t("login.footerPrivacy")}</Link>
          <Link to="/terms">{t("login.footerTerms")}</Link>
          <Link to="/data-deletion">{t("login.footerDeletion")}</Link>
        </nav>
        <div className="lp-foot-controls">
          <button
            className="lp-lang-toggle"
            onClick={() => i18n.changeLanguage(i18n.language.startsWith("en") ? "ru" : "en")}
          >
            <span>{i18n.language.startsWith("en") ? "RU" : "EN"}</span>
          </button>
        </div>
        <span className="lp-foot-meta">
          © {new Date().getFullYear()} Stingray Selling Products &amp; Services by Automatic Vending Machines CO. L.L.C S.O.C
        </span>
      </div>
    </footer>
  );
};
